function t(t,e){let n=Object.getOwnPropertyNames(t);const r={};for(let s=0;s<n.length;s++){const g=n[s];g.substring(0,e.length)===e&&(r[g.substring(e.length)]=t[g])}return r}export{t as prefixFilter};
//# sourceMappingURL=prefixFilter.js.map
